import { each, find, isEmpty, toNumber, toPairs, toString } from 'lodash';

import { formatLocalizedCurrency } from 'helpers';
import i18n from 'translations';

export const CART_TIMER_DURATION_MINUTES = 20;

export const leisureService = {
  getSelectedSession: ({ sessions, placement, onPlan }) => {
    let foundSession;

    each(sessions, (session) => {
      foundSession = find(session.list, (item) => {
        return onPlan
          ? item.customerNatureId === toNumber(placement.customerNatureId)
          : item.priceId === placement.articleId;
      });
      if (foundSession) {
        return false; // Break the loop once the item is found
      }
    });
    return foundSession;
  },
  getTmLabel: ({ sessions, leisure, placement, onPlan }) => {
    let label = leisure?.title?.trim() || '';
    let session = leisureService.getSelectedSession({ sessions, placement, onPlan });

    if (session) {
      label += ` ${session.categoryLabel} ${session.customerNatureLabel}`;
    }

    return label;
  },
  formatTicketmasterPayload: ({ sessions, planValues, payload, leisure, sessionId }) => {
    //Format the payload for the ticketmaster (onPlan or not) for TOULOISIRS products (castelis API)
    if (planValues) {
      each(planValues, (value) => {
        payload = {
          ...payload,
          placement: [
            ...payload.placement,
            {
              articleId: value.idseanc,
              qty: 1,
              customerNatureId: value.idnatcli,
              zoneId: value.idzone,
              placementId: value.idplac,
              placementRank: value.rgplac,
              placementCategoryCode: value.codcatpl,
              placementNumber: value.numplac,
              contyCode: value.codconty
            }
          ]
        };
      });
    } else {
      // Format the payload for the ticketmaster products selected FROM THE SUMMARY (not on plan)
      each(sessions, (session) => {
        if (!isEmpty(session.selectedPlacement)) {
          each(session.list, (item) => {
            if (item.selectedQty > 0) {
              payload = {
                ...payload,
                placement: [
                  ...payload.placement,
                  {
                    articleId: item.priceId,
                    qty: item.selectedQty,
                    customerNatureId: item.customerNatureId,
                    categoryCode: toString(item.categoryCode),
                    categoryDisp: session.selectedPlacement.value
                  }
                ]
              };
            }
          });
        }
      });
    }

    // Format the payload for the ticketmaster items added to cart (checkout API)
    payload = payload.placement.map((placement) => {
      return {
        productId: leisure.productId,
        quantity: placement.qty,
        categoryId: leisure.category,
        typeItem: leisure?.typeItem?.toString(),
        options: {
          optionsType: planValues ? 'TICKETMASTER_ON_PLAN' : 'TICKETMASTER',
          sessionId,
          placement: {
            ...placement,
            tarifId: placement.articleId,
            customerNatureId: toNumber(placement.customerNatureId),
            ...(!planValues && { categoryCode: toString(placement.categoryCode) })
          }
        }
      };
    });

    return payload;
  },
  formatTicketmasterModalContent: (sessions) => {
    // Format the content of the modal to display the selected items (not on plan) added to cart
    let content = [];

    each(sessions, (session) => {
      if (!isEmpty(session.selectedPlacement)) {
        each(session.list, (item) => {
          if (item.selectedQty > 0) {
            content = [
              ...content,
              {
                subLabel: `${item.categoryLabel} ${item.customerNatureLabel}`,
                quantity: item.selectedQty,
                total: item.unitPrice * item.selectedQty
              }
            ];
          }
        });
      }
    });

    return content;
  },
  formatTicketmasterOnPlanModalContent: (sessions, planValues) => {
    // Format the content of the modal to display the selected ticketmaster items added to cart
    let content = [];

    const findCategory = (planValue) => {
      let category;
      for (let i = 0; i < sessions.length; i++) {
        category = sessions[i].list?.find((item) => item.categoryCode === planValue.codcatpl);
        if (category) break;
      }
      return category;
    };

    each(planValues, (value) => {
      const sessionCategory = findCategory(value);
      let subLabel = '';
      let total = 0;

      if (sessionCategory) {
        total = sessionCategory.unitPrice;
        subLabel = `${sessionCategory.categoryLabel} ${sessionCategory.customerNatureLabel}`;

        if (value?.rgplac && value?.numplac) {
          const rank = i18n.getResource(i18n.resolvedLanguage, 'products', 'rank');
          const seat = i18n.getResource(i18n.resolvedLanguage, 'products', 'seat');
          subLabel = `${subLabel} (${rank} ${value.rgplac}, ${seat} ${value.numplac})`;
        }
      }
      content = [...content, { subLabel, quantity: 1, total }];
    });

    return content;
  },
  formatArticlePayload: ({ quantity, payload, prices, leisure }) => {
    each(toPairs(quantity), ([id, qty]) => {
      if (qty > 0) {
        payload = {
          ...payload,
          placement: [
            ...payload.placement,
            {
              articleId: id,
              qty
            }
          ]
        };
      }
    });

    payload = payload.placement.map((item) => {
      const tarif = prices.find((price) => price.id === item.articleId);

      return {
        productId: leisure?.productId,
        quantity: item.qty,
        categoryId: leisure.category,
        typeItem: leisure?.typeItem?.toString(),
        options: {
          optionsType: 'ARTICLE',
          tarifId: tarif?.id
        }
      };
    });

    return payload;
  },
  sumValues: ({ quantity, prices, key }) => {
    return toPairs(quantity).reduce((acc, [id, quantity]) => {
      const currentPrice = prices.find((price) => price.id === id);

      if (key === 'price') {
        // Calculate total price for all articles in the cart without any discount
        return acc + currentPrice[key] * quantity;
      } else {
        // Calculate total discount price for all articles in the cart
        if (!currentPrice.subsidizedPrice) return acc;
        return acc + (currentPrice.price - currentPrice[key]) * quantity;
      }
    }, 0);
  },
  leisurePricesResume: (params) => {
    return {
      total: formatLocalizedCurrency(leisureService.sumValues({ ...params, key: 'price' })),
      employerDiscount: formatLocalizedCurrency(leisureService.sumValues({ ...params, key: 'subsidizedPrice' })),
      netPrice: formatLocalizedCurrency(
        leisureService.sumValues({ ...params, key: 'price' }) -
          leisureService.sumValues({ ...params, key: 'subsidizedPrice' })
      )
    };
  }
};
